export default __webpack_public_path__ + "static/media/banner-image.5c946368.webp";